var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterlogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Twitter logo",
    clipPath: "url(#clip0_116_368)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18 1.7049C17.326 1.98937 16.611 2.1761 15.879 2.25887C16.6415 1.82346 17.227 1.13398 17.5027 0.312468C16.7778 0.722276 15.9847 1.01101 15.1577 1.1662C14.484 0.482477 13.5243 0.0551758 12.4621 0.0551758C10.4226 0.0551758 8.76909 1.63041 8.76909 3.57326C8.76909 3.84904 8.80179 4.11752 8.86472 4.37508C5.79558 4.22831 3.07448 2.82771 1.25304 0.699175C0.935227 1.21878 0.753117 1.82319 0.753117 2.46786C0.753117 3.68848 1.40513 4.76527 2.39597 5.39621C1.80953 5.37871 1.23599 5.22781 0.723234 4.95611C0.723023 4.97085 0.723023 4.98559 0.723023 5.00039C0.723023 6.70497 1.99596 8.12694 3.68529 8.45015C3.14148 8.59105 2.57107 8.61167 2.01762 8.51044C2.48752 9.90816 3.85137 10.9253 5.46729 10.9537C4.20342 11.8973 2.61105 12.4598 0.880945 12.4598C0.58282 12.4598 0.288914 12.4431 0 12.4106C1.63427 13.4088 3.57539 13.9913 5.66086 13.9913C12.4535 13.9913 16.1679 8.63034 16.1679 3.98127C16.1679 3.82868 16.1644 3.67695 16.1573 3.5261C16.8802 3.02819 17.5042 2.41147 18 1.7049Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_116_368"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterlogo);
export default __webpack_public_path__ + "static/media/Twitter logo.9689f794957d9aaee054151cf82d6af0.svg";
export { ForwardRef as ReactComponent };